import React from 'react';

export const CompilationSvg = ({ ...rest }) => {
  return (
    <svg
      width="313"
      height="292"
      viewBox="0 0 313 292"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect width="313" height="292" rx="10" fill="#F1F1F1" />
      <rect y="23" width="313" height="191" fill="#8D8D8D" />
      <path
        d="M0 10C0 4.47715 4.47715 0 10 0H303C308.523 0 313 4.47715 313 10V23H0V10Z"
        fill="#A4A4A4"
      />
      <path d="M11 230H73.5463" stroke="#A4A4A4" strokeWidth="10" strokeLinecap="round" />
      <path d="M9.12695 242H156.5" stroke="#A4A4A4" strokeWidth="5" strokeLinecap="round" />
      <path d="M9.12695 251H19.3276" stroke="#A4A4A4" strokeWidth="4" strokeLinecap="round" />
      <path
        d="M234 229.5C234 233.09 231.09 236 227.5 236C223.91 236 221 233.09 221 229.5C221 225.91 223.91 223 227.5 223C231.09 223 234 225.91 234 229.5Z"
        fill="#CFCFCF"
      />
      <path
        d="M250 229.5C250 233.09 247.09 236 243.5 236C239.91 236 237 233.09 237 229.5C237 225.91 239.91 223 243.5 223C247.09 223 250 225.91 250 229.5Z"
        fill="#CFCFCF"
      />
      <path
        d="M266 229.5C266 233.09 263.09 236 259.5 236C255.91 236 253 233.09 253 229.5C253 225.91 255.91 223 259.5 223C263.09 223 266 225.91 266 229.5Z"
        fill="#CFCFCF"
      />
      <path
        d="M282 229.5C282 233.09 279.09 236 275.5 236C271.91 236 269 233.09 269 229.5C269 225.91 271.91 223 275.5 223C279.09 223 282 225.91 282 229.5Z"
        fill="#CFCFCF"
      />
      <path
        d="M298 229.5C298 233.09 295.09 236 291.5 236C287.91 236 285 233.09 285 229.5C285 225.91 287.91 223 291.5 223C295.09 223 298 225.91 298 229.5Z"
        fill="#CFCFCF"
      />
      <path d="M11 11.5H45.5" stroke="white" strokeWidth="11" strokeLinecap="round" />
      <circle cx="298" cy="11.5" r="8.5" fill="white" />
      <path d="M248.5 9H283.5" stroke="white" strokeWidth="4" strokeLinecap="round" />
      <path d="M255.5 15H283.5" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path
        d="M146 108.495C146 106.121 148.626 104.688 150.622 105.971L167.075 116.548C168.911 117.729 168.911 120.414 167.075 121.595L150.622 132.171C148.626 133.455 146 132.021 146 129.648V108.495Z"
        fill="#F0EDED"
      />
    </svg>
  );
};

export default CompilationSvg;



// WEBPACK FOOTER //
// ./src/vp-ui/svgs/CompilationSvg.jsx